import React from "react";
import getConfig from "next/config";
import Link from "next/link";

const { publicRuntimeConfig } = getConfig();

import { useRouter } from "next/router";

function SecondaryMenu() {
  const router = useRouter();

  return (
    <>
      <div className="secondary-menu">
        <div className="link-wrapper">
          <Link href={`/about`}>
            <a className={router.pathname.includes("about") ? "active" : ""}>
              About Us
            </a>
          </Link>
        </div>
        <div className="link-wrapper">
          <Link href={`/faq`}>
            <a className={router.pathname.includes("faq") ? "active" : ""}>
              FAQs
            </a>
          </Link>
        </div>
        <div className="link-wrapper">
          <Link href={`/guarantee`}>
            <a className={router.pathname.includes("guarantee") ? "active" : ""}>
              Our Guarantee
            </a>
          </Link>
        </div>
      </div>
    </>
  );
}

export default SecondaryMenu;
